/** Successful writes invalidate server-derived notices. */
const listeners = new Set<() => void>();
export function onRunnerMutation(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function runnerMutationCompleted(): void {
  for (const listener of listeners) {
    try { listener(); } catch { /* An observer cannot turn an accepted write into a failure. */ }
  }
}
